"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.book = void 0;
var _config = require("../../services/config");
var book = exports.book = {
  get search() {
    return (0, _config.getBasePath)();
  },
  get carts() {
    return "".concat((0, _config.getBasePath)(), "/cart");
  },
  get collections() {
    return "".concat((0, _config.getBasePath)(), "/collections");
  },
  get offer() {
    return "".concat((0, _config.getBasePath)(), "/offer/:hotelID/:offerID");
  },
  get offerV2() {
    return "".concat((0, _config.getBasePath)(), "/offer/:offerID");
  },
  get hotel() {
    return "".concat((0, _config.getBasePath)(), "/hotel/:hotelID");
  }
};